import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadCrumbElement } from '../../../../../shared/entities/breadcrumb.element.entity';
import { DestinationFilterComponent } from '../../components/destination-filter/destination-filter.component';
import { DestinationAction } from '../../model/destination-action.enum';
import { DestinationSearchParams } from '../../params/destination-search.params';
import { Observable, forkJoin } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { DestinationField } from '../../model/destination-field.enum';
import { PaginatedResponse } from '../../../../../shared/models/paginated-response';
import { DestinationResponse } from '../../responses/destination.response';
import { Pagination } from '../../../../../shared/models/pagination';
import { DestinationUtilsService } from '../../destination-utils.service';
import { BotMergeDestinationState } from '../../../../../shared/models/bot-merge-destinations-state';
import { DestinationService } from '../../destination.service';
import { ImportProgressResponse } from '../../responses/import-progress.response';
import { LoadingIndicatorService } from '../../../../../services/loading-indicator/loading-indicator.service';

@Component({
    selector: 'app-destinations-finished',
    templateUrl: './destinations-finished.component.html',
    styleUrls: ['./destinations-finished.component.css'],
})
export class DestinationsFinishedComponent implements OnInit {
    @ViewChild(DestinationFilterComponent)
    destinationFilter: DestinationFilterComponent;
    readonly additionalFields = [
        DestinationField.LastImportDate,
        DestinationAction.Download,
        DestinationAction.InProgressStats,
        DestinationAction.ImportStats,
        DestinationAction.Import,
    ];
    destinations: DestinationResponse[] = [];
    searchParams: DestinationSearchParams = {
        state: BotMergeDestinationState.FINISHED,
    };
    pagination: Pagination = {
        page: 1,
        limit: 20,
    };
    /* */
    public breadCrumbElements: Array<BreadCrumbElement> = [
        new BreadCrumbElement('tripmakery', 'javascript:void(0)'),
        new BreadCrumbElement('Bot', 'javascript:void(0)'),
        new BreadCrumbElement('Finished', 'javascript:void(0)'),
    ];
    /* */
    public backgroundImage = '/assets/media/photos/photo21@2x.jpg';
    public containerBackgroundImage = {
        'background-image': 'url(' + this.backgroundImage + ')',
    };
    public subContainerBackgroundImage = {};
    public containerClass = { 'bg-image': true };
    public subContainerClass = { 'bg-white-op-90': true };
    public contentClass: any = {
        content: true,
        'text-center': true,
        'content-top': true,
    };
    public pyClass = { 'py-50': true };
    public h1class: any = { h1: true };
    public h2class: any = { h4: true };
    public importProgress: { [key: string]: ImportProgressResponse } = {};
    private _importProgressInterval: any;

    constructor(
        private destinationService: DestinationService,
        private loadingIndicatorService: LoadingIndicatorService,
        private destinationUtilsService: DestinationUtilsService
    ) {}

    ngOnInit() {}
    ngAfterViewInit() {
        // run this after the view is initialized to ensure the filter component is available
        this.reloadDestinations();
    }
    ngOnDestroy() {
        if (this._importProgressInterval) {
            clearInterval(this._importProgressInterval);
        }
    }

    actionClicked(data: {
        action: DestinationAction;
        destination: DestinationResponse;
    }) {
        this.destinationUtilsService.actionClicked(data);
    }

    reloadDestinations(resetPage: boolean = false) {
        if (resetPage) {
            this.pagination.page = 1;
        }
        window.scrollTo(0, 250);
        this.loadDestinations().subscribe(() => {
            this._loadImportProgress();
            this._importProgressInterval = setInterval(() => {
                this._loadImportProgress({ showLoadingIndicator: false });
            }, 10_000);
        });
    }

    private _loadImportProgress(
        params: { showLoadingIndicator?: boolean } = {
            showLoadingIndicator: true,
        }
    ) {
        const destinationIds = this.destinations.map((d) => d.boundary._id);

        if (params.showLoadingIndicator) {
            this.loadingIndicatorService.showLoadingBar();
        }
        const observables = destinationIds.map((id) =>
            this.destinationService.importProgress(id).pipe(
                tap((res) => {
                    this.importProgress = { ...this.importProgress, [id]: res };
                })
            )
        );

        if (observables.length === 0) {
            this.loadingIndicatorService.hideLoadingBar();
            return;
        }
        forkJoin(...observables).subscribe(
            (res) => {
                this.loadingIndicatorService.hideLoadingBar();
            },
            (err) => {
                this.loadingIndicatorService.hideLoadingBar();
            }
        );
    }

    private loadDestinations(): Observable<
        PaginatedResponse<DestinationResponse>
    > {
        const params = {
            ...this.pagination,
            ...this.destinationFilter.formValue,
        };
        return this.destinationUtilsService.loadDestinations(params).pipe(
            tap((data) => {
                this.destinations = data.elements;
                this.pagination = data.pagination;
            })
        );
    }
    public sendPage(page: number) {
        this.pagination.page = page;
        this.reloadDestinations();
    }
}
